module.exports = __webpack_public_path__ + "static/kesem-4-6994ed5c36871e72e58c12eee42dd184.png";